import { withSvgIcon } from './withSvgIcon';

export const TopUp = withSvgIcon(
  <>
    <path
      clipRule="evenodd"
      d="M6 3a3 3 0 0 0-3 3v7h2V8.83c.312.11.649.17 1 .17H18A1 1 0 0 1 19 10v7a1 1 0 0 1-1 1h-6v2h6a3 3 0 0 0 3-3v-7a3 3 0 0 0-3-3H6A1 1 0 1 1 6 5h13V3H6Zm10.5 12a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"
      fill="currentColor"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M5 19v3h2v-3h3v-2H7v-3H5v3H2v2h3Z"
      fillRule="evenodd"
      fill="currentColor"
    />
  </>,
  { viewBox: '0 0 24 24' },
);
